<template src='./index.html'></template>
<script>
import { getdata } from './data.js';
import ywlxgltj from '@/components/common/ywlxgz/ywgz/ywlxgl/ywlxgltj/index.vue';
import xjgz from '@/components/common/ywlxgz/ywgz/xjgz/index.vue';
import { ywlxgl_query, ywlxgz_scgz } from '@/api/ywlxgz';
import { comMapping } from '@/components/util/Function/comMapping';

export default {
    name: '',
    components: {
        xjgz,
        ywlxgltj // 业务类型管理添加弹框
    },
    props: {
        ywlxgldialog: {
            type: Boolean,
            default: false
        },
        ywzx:{
            type: String,
            default: "0"
        }
    },
    watch: {
        ywlxgldialog:function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {
                    this.loadBusinessData();
                });
            }
        },
    },
    data: function() {
        return {
            searchdata: getdata().searchdata,
            searchlist: getdata().searchlist,
            tablekey: 0,
            overlength: 0,
            headData: getdata().headData,
            tableData: [],
            pagination: getdata().pagination,
            ywlxgltjdialog: false,
            ywlxgltjdialogTitle: '',
            searchdiag: false,
            ywzl: comMapping.$ywzx,
            qzfw: comMapping.$qzfw,
            sjlx: comMapping.$sjlx,
            formData: {}
        };
    },
    mounted() {
    },
    created() {
        this.loadBusinessData();
    },
    methods: {
        geOoverLength(e){
		  this.overlength = e;
	    },
        loadBusinessData() {
            let params = JSON.parse(JSON.stringify(this.searchdata));
            params.current = this.pagination.pageNum;
            params.size = this.pagination.pageSize;
            params.sort = '';
            params.order = '';
            ywlxgl_query(params).then(res => {
                if (res.data.code !== "1") {
                    this.$message.error(res.data.msg);
                } else {
                    this.pagination.total = res.data.data.total;
                    this.tableData = res.data.data.records;
                }
            });
        },
        closediag() {
            this.$emit('closediag', false);
        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.loadBusinessData();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.loadBusinessData();
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.loadBusinessData();
        },
        forRefresh() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
        },
        forUpdateSearch() {
            this.searchdiag = true;
        },
        closeSearch() {
            this.searchdiag = false;
        },
        saveChange(e) {
            this.searchdiag = false;
        },
        addBusiness() {
            // 添加按钮点击
            this.ywlxgltjdialogTitle = "新建业务类型管理";
            this.ywlxgltjdialog = true;
            this.formData = {"bsType":"1"}
        },
        ywlxgltjclosediag() {
            this.ywlxgltjdialog = false;
            this.loadBusinessData();
        },
        businessEdit(e) {
            // 编辑按钮
            this.ywlxgltjdialogTitle = "编辑业务类型管理";
            this.ywlxgltjdialog = true
            this.formData = e
        },
        businessDelete(e) {
            // 删除按钮
            this.$showConfirm({
                message: "确认删除【"+e.bsName+"】该规则吗？",
            }).then((result) => {
                if (result === "confirm") {
                    let params = {id: e.id, code: e.code};
                    ywlxgz_scgz(params).then(res => {
                        if (res.data.code !== "1") {
                            this.$message.error(res.data.msg);
                        } else {
                            this.$message.success(res.data.msg);
                            this.loadBusinessData();
                        }
                    })
                }
            })
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
